/* Source: /home/sidsolaiyappan/skooch_ai/shared/supabase_config.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { createClient } from "@supabase/supabase-js";
function get_supabase() {
  try {
    if (window.__skoochSupabase) {
      return window.__skoochSupabase;
    }
  } catch (__jac_e) {
    if (true) {
      let _winErr = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  let env = import.meta.env;
  let url = ((env.VITE_SUPABASE_URL || env.SUPABASE_URL) || "");
  let key = ((((env.VITE_SUPABASE_ANON_KEY || env.SUPABASE_ANON_KEY) || env.VITE_SUPABASE_KEY) || env.SUPABASE_KEY) || "");
  let _client = createClient(url, key);
  try {
    window.__skoochSupabase = _client;
  } catch (__jac_e) {
    if (true) {
      let _setErr = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  return _client;
}
function supabasePublicAsset(path) {
  let env = import.meta.env;
  let _base = ((env.VITE_SUPABASE_URL || env.SUPABASE_URL) || "");
  return ((String(_base) + "/storage/v1/object/public/") + String(path));
}
export {get_supabase, supabasePublicAsset};
if (typeof globalThis !== "undefined") { if (!globalThis.__jacEndpointEffects__) globalThis.__jacEndpointEffects__ = {}; Object.assign(globalThis.__jacEndpointEffects__, {"func:get_supabase": {"is_writer": true, "touches": ["*"]}, "func:supabasePublicAsset": {"is_writer": false, "touches": ["*"]}}); };
//# sourceMappingURL=supabase_config.js.map
